// @ts-strict-ignore
import { ApplyTextToTextureAreaUsageQuickFixActionVO, ArticleDescriptorVO, DeleteArticleQuickFixActionVO, InsertArticleQuickFixActionVO, QuickFixActionVO, UsageArticleDescriptorVO } from '@project/model/vo/validation-context.vo';
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';
import { RelativePositionReferenceArticleLocationVO } from '@project/components/article/model/vo/relative-position-reference-article-location.vo';
import { ReplaceReferenceArticleLocationVO } from '@article/model/vo/replace-reference-article-location.vo';

export class QuickFixUtils {
  public static getOperatingLocationOfQuickFixActionAsExistingArticleUsageId(action: QuickFixActionVO): string {
    if (action instanceof DeleteArticleQuickFixActionVO) {
      const deleteArticleQuickFixAction: DeleteArticleQuickFixActionVO = action;
      return this.getArticleUsageIdFromArticleDescriptor(deleteArticleQuickFixAction.articleDescriptor);
    } else if (action instanceof InsertArticleQuickFixActionVO) {
      const insertArticleQuickFixAction: InsertArticleQuickFixActionVO = action;
      return this.getArticleUsageIdFromArticleLocation(insertArticleQuickFixAction.articleLocation);
    } else if (action instanceof ApplyTextToTextureAreaUsageQuickFixActionVO) {
      const applyTextToTextureAreaUsageQuickFixActionVO: ApplyTextToTextureAreaUsageQuickFixActionVO = action;
      return !applyTextToTextureAreaUsageQuickFixActionVO.textureAreaUsageIdentity ?
        null : applyTextToTextureAreaUsageQuickFixActionVO.textureAreaUsageIdentity.articleUsageId;
    } else {
      return null;
    }
  }

  private static getArticleUsageIdFromArticleDescriptor(articleDescriptor: ArticleDescriptorVO): string {
    if (articleDescriptor instanceof UsageArticleDescriptorVO) {
      return articleDescriptor.articleUsageId;
    }
    return null;
  }

  private static getArticleUsageIdFromArticleLocation(articleLocation: ArticleLocationVO): string {
    if (articleLocation instanceof RelativePositionReferenceArticleLocationVO) {
      return articleLocation.referenceArticleUsage.id;
    } else if (articleLocation instanceof ReplaceReferenceArticleLocationVO) {
      return articleLocation.articleUsageIdToReplace;
    }
    return null;
  }
}
